var _defs, _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDevelopment = function SvgDevelopment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Development_svg__f640fa6c-59ef-4187-879e-4dde7e597ace{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Development_svg__aaa3ed02-833e-4e12-914d-b4aee0ae252e",
    "data-name": "Development"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h250v250H0z"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "Development_svg__f640fa6c-59ef-4187-879e-4dde7e597ace",
    x: 47.13,
    y: 71.03,
    width: 155.74,
    height: 107.94,
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Development_svg__f640fa6c-59ef-4187-879e-4dde7e597ace",
    d: "M47.13 87.92h155.74M97.01 115.93l-17.97 18.26 17.97 17.69M152.99 115.93l17.97 18.26-17.97 17.69M134.38 108.34l-18.76 51.13"
  }))));
};

export default SvgDevelopment;